export default ctx => {
  ctx.app.apolloProvider.defaultClient.writeData({
    data: {
      errors: []
    }
  })
}
